import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: 'email',
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderBody(h, options) {
  const { path, serviceName, defaults } = options

  let passwordAfterIcon
  let passwordType
  if (this.passwordVisibility) {
    passwordAfterIcon = 'visibility'
    passwordType = 'password'
  } else {
    passwordAfterIcon = 'visibility_off'
    passwordType = 'text'
  }

  return h(
    'div',
    {
      class: 'grid grid-gap--12 pt-2 px-2'
    },
    [
      h(
        'div',
        {
          class: {
            'grid grid-gap--8': true,
            'grid-cols--2': this.viewport.breakpoint.mdUp
          }
        },
        [
          h(
            components['text-field'],
            {
              props: {
                value: this.proxy.host,
                label: this.getTranslate(`${serviceName}.labels.${path}.host`),
                defaultValue: defaults?.[path].host,
                ...this.commonFieldsProps
              },
              on: {
                input: event => {
                  this.proxy.host = event
                }
              }
            }
          ),

          h(
            components['text-field'],
            {
              props: {
                value: this.proxy.port,
                label: this.getTranslate(`${serviceName}.labels.${path}.port`),
                defaultValue: defaults?.[path].port,
                type: 'number',
                step: 'any',
                ...this.commonFieldsProps
              },
              on: {
                input: event => {
                  this.proxy.port = event
                }
              }
            }
          )
        ]
      ),

      h(
        components['text-field'],
        {
          props: {
            value: this.proxy.from,
            label: this.getTranslate(`${serviceName}.labels.${path}.from`),
            defaultValue: defaults?.[path].from,
            ...this.commonFieldsProps
          },
          on: {
            input: event => {
              this.proxy.from = event
            }
          }
        }
      ),

      h(
        'div',
        {
          class: {
            'grid grid-gap--8': true,
            'grid-cols--2': this.viewport.breakpoint.mdUp
          }
        },
        [
          h(
            components['text-field'],
            {
              props: {
                value: this.proxy.login,
                label: this.getTranslate(`${serviceName}.labels.${path}.login`),
                defaultValue: defaults?.[path].login,
                ...this.commonFieldsProps
              },
              on: {
                input: event => {
                  this.proxy.login = event
                }
              }
            }
          ),
          h(
            components['text-field'],
            {
              props: {
                value: this.proxy.password,
                label: this.getTranslate(`${serviceName}.labels.${path}.password`),
                defaultValue: defaults?.[path].password,
                name: 'smtp-password',
                afterIcon: passwordAfterIcon,
                afterIconCallback: () => {
                  this.passwordVisibility = !this.passwordVisibility
                },
                type: passwordType,
                ...this.commonFieldsProps
              },
              on: {
                input: event => {
                  this.proxy.password = event
                }
              }
            }
          )
        ]
      )
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer'
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.save,
            color: Colors.primary,
            mode: buttonModes.flat,
            label: this.getTranslate('misc.buttons.save'),
            loading: this.loading,
            disabled: this.disabled
          },
          on: {
            click: () => {
              this.submit()
            }
          }
        }
      )
    ]
  )
}
function renderContent(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0'
    },
    [
      renderBody.call(this, h, options),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderContent.call(this, h, options)
        }
      }
    }
  )
}
